import consts from '@/api/constants';
import credentialsEncryptor from '@/utils/credentialsEncryptor';
import { client } from '../http';

async function fetchOnboardingState() {
  const response = await client.get('/api/onboarding-state');
  return response.data;
}

async function nextOnboardingPage() {
  const response = await client.post('/api/onboarding-state/next-page');
  return response.data;
}

async function back() {
  const response = await client.post('/api/onboarding-state/back');
  return response.data;
}

async function updateOnboardingPage(onboardingPage) {
  const response = await client.put('/api/onboarding-state', { onboardingPage });
  return response.data;
}

async function botiIntroSubmit() {
  const response = await client.post('/api/onboarding-state/boti-intro/submit');
  return response.data;
}

async function progressIndicationOneSubmit() {
  const response = await client.post('/api/onboarding-state/progress-indication-one/submit');
  return response.data;
}

async function progressIndicationTwoSubmit() {
  const response = await client.post('/api/onboarding-state/progress-indication-two/submit');
  return response.data;
}

async function securityInformationSubmit() {
  const response = await client.post('/api/onboarding-state/security-information/submit');
  return response.data;
}

async function accountInvestigationSubmit(inputs) {
  const response = await client.post('/api/onboarding-state/account-investigation/submit', { inputs });
  return response.data;
}

async function incomeInvestigationSubmit(inputs) {
  const response = await client.post('/api/onboarding-state/income-investigation/submit', { inputs });
  return response.data;
}

async function expenseInvestigationSubmit(inputs) {
  const response = await client.post('/api/onboarding-state/expense-investigation/submit', { inputs });
  return response.data;
}

async function bankSelectionSubmit({ sourceName, credentials, name, sourceType }) {
  const encryptedCredentials = _safeEncrypt(credentials, { name, sourceName });
  const response = await client.post('/api/onboarding-state/bank-selection/submit', {
    encryptedCredentials, name, user: consts.CUSTOMER_USER, sourceName, sourceType,
  });
  return response.data;
}

async function creditCardDetailsSubmit({ sourceName, credentials, name, sourceType }) {
  const encryptedCredentials = _safeEncrypt(credentials, { name, sourceName });
  const response = await client.post('/api/onboarding-state/credit-card-details/submit', {
    encryptedCredentials, name, user: consts.CUSTOMER_USER, sourceName, sourceType,
  });
  return response.data;
}

function _safeEncrypt(object, logData) {
  const encrypted = credentialsEncryptor.encrypt(object);
  if (encrypted === 'false') {
    throw new Error(`Failed encrypting object ${JSON.stringify(logData)}`);
  }
  return encrypted;
}

export default {
  nextOnboardingPage,
  fetchOnboardingState,
  updateOnboardingPage,
  back,
  botiIntroSubmit,
  progressIndicationOneSubmit,
  securityInformationSubmit,
  accountInvestigationSubmit,
  incomeInvestigationSubmit,
  expenseInvestigationSubmit,
  progressIndicationTwoSubmit,
  bankSelectionSubmit,
  creditCardDetailsSubmit,
};
